import { render, staticRenderFns } from "./EdudashButton.vue?vue&type=template&id=18a9fd2a&scoped=true&"
import script from "./EdudashButton.vue?vue&type=script&lang=js&"
export * from "./EdudashButton.vue?vue&type=script&lang=js&"
import style0 from "./EdudashButton.vue?vue&type=style&index=0&id=18a9fd2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a9fd2a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
